<template>
  <div>
     <figure class="image">
      <img src="../assets/img1.png">
    </figure>
  </div>
</template>

<script>
  export default {
    name : "SideImage"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/componests/SideImage.vue